import { defaultClient } from '../clients.js';
import {
  ConversionMetricsResponseSchema,
  ConversionQuerySchema,
  CreateMetricRequestSchema,
  IntegrationQuerySchema,
  ListMetricsQuerySchema,
  MetricOptionResponseSchema,
  MetricOptionsQuerySchema,
  MetricsIntegrationsResponseSchema,
  ResponseDataMetricSchema,
  UpdateMetricRequestSchema,
} from './schemas/metrics.js';

export const getMetricIntegrationsQueryOptions = defaultClient.query({
  url: 'mdm/field-definition/metrics/integrations' as const,
  method: 'GET',
  responseSchema: MetricsIntegrationsResponseSchema,
  querySchema: IntegrationQuerySchema,
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data.data;
  },
});

export const getMetricConversionsQueryOptions = defaultClient.query({
  url: 'mdm/field-definition/metrics/conversions' as const,
  method: 'GET',
  responseSchema: ConversionMetricsResponseSchema,
  querySchema: ConversionQuerySchema,
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data.data;
  },
});

export const getMetricsListQuery = defaultClient.query({
  url: 'mdm/metric/',
  method: 'GET',
  querySchema: ListMetricsQuerySchema,
  responseSchema: ResponseDataMetricSchema,
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data.data;
  },
});

export const createMetricEndpoint = defaultClient.query({
  url: 'mdm/metric/',
  method: 'POST',
  requestSchema: CreateMetricRequestSchema,
  responseSchema: ResponseDataMetricSchema,
});

export const updateMetricEndpoint = defaultClient.mutation({
  url: 'mdm/metric/$metricId' as const,
  method: 'PUT',
  requestSchema: UpdateMetricRequestSchema,
  responseSchema: ResponseDataMetricSchema,
  processResponse: (data) => data,
});

export const getMetricsOptionsQuery = defaultClient.query({
  url: 'mdm/metric/options' as const,
  method: 'GET',
  responseSchema: MetricOptionResponseSchema,
  querySchema: MetricOptionsQuerySchema,
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data.data;
  },
});
